module.exports = __webpack_public_path__ + "media/Instruction_66.b568195a.mp3";